import { helper } from '@ember/component/helper';

const assignHelper = helper((positional: any[]) => Object.assign({}, ...positional));

export default assignHelper;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    assign: typeof assignHelper;
  }
}
